// Kindness certificates — mock data
export const certificates = [
  {
    id: "cert-2026-0142",
    recipient: "Ada Lovelace",
    location: "Brooklyn, NY",
    tier: "Bronze",
    dateIssued: "February 14, 2026",
    verificationCode: "NN-2026-0142-BR",
    personHelped: "Mrs. Patel & 11 other neighbors",
    stats: {
      livesTouched: 12,
      meals: 34,
      hours: 47,
      jobsCreated: 2,
      impactScore: 812,
    },
    story: "Weekly groceries, tutoring for two kids, and three medical rides — all quietly, all consistently.",
  },
  {
    id: "cert-2026-0121",
    recipient: "James Okafor",
    location: "Austin, TX",
    tier: "Silver",
    dateIssued: "February 10, 2026",
    verificationCode: "NN-2026-0121-SL",
    personHelped: "42 families across East Austin",
    stats: {
      livesTouched: 42,
      meals: 128,
      hours: 96,
      jobsCreated: 7,
      impactScore: 1450,
    },
    story: "Founded a weekend food-rescue circle that redistributes surplus grocery-store produce.",
  },
  {
    id: "cert-2026-0098",
    recipient: "Priya Anand",
    location: "Bangalore, IN",
    tier: "Gold",
    dateIssued: "January 28, 2026",
    verificationCode: "NN-2026-0098-GD",
    personHelped: "87 students, first-gen career mentees",
    stats: {
      livesTouched: 87,
      meals: 12,
      hours: 214,
      jobsCreated: 61,
      impactScore: 2340,
    },
    story: "Mentored 87 students through career transitions — 61 landed their first tech jobs.",
  },
];
